import * as forbes from './static/img/forbes.svg';
import * as forbesColored from './static/img/forbes-colored.svg';

import * as habr from './static/img/habr.svg';
import * as habrColored from './static/img/habr-colored.svg';

import * as rbk from './static/img/rbk.svg';
import * as rbkColored from './static/img/rbk-colored.svg';

import * as vc from './static/img/vc.svg';
import * as vcColored from './static/img/vc-colored.svg';

export const getArticles = (t: Function) => [
  {
    image: [forbes, forbesColored],
    title: t('How do you give money into management to 200 traders at once'),
    date: '2013-04-04',
    link: 'https://www.forbes.ru/finansy/investitsii/236638-kak-otdat-dengi-v-upravlenie-srazu-200-treideram',
  },
  {
    image: [vc, vcColored],
    title: t('How to choose a company to invest in OTC and pre-IPO'),
    date: '2019-02-08',
    link: 'https://vc.ru/finance/57946-kak-vybrat-startap-dlya-investirovaniya',
  },
  {
    image: [rbk, rbkColored],
    title: t('Where to invest money during a financial crisis Optios risks fears'),
    date: '2020-04-12',
    link: 'https://www.rbc.ru/crypto/news/5e8c58869a79477873fe939c',
  },
  {
    image: [habr, habrColored],
    title: t('How development works at United Traders'),
    date: '2019-03-11',
    link: 'https://habr.com/ru/company/utex/blog/443300/',
  },
  {
    image: [vc, vcColored],
    title: t('Pinterest goes public The company is valued at $12 billion'),
    date: '2019-02-28',
    link: 'https://vc.ru/finance/59861-pinterest-vyhodit-na-ipo-pochemu-servis-s-kartinkami-dlya-devochek-stoit-12-mlrd',
  },
  {
    image: [habr, habrColored],
    title: t('Why invest in loss-making companies'),
    date: '2019-04-05',
    link: 'https://habr.com/ru/company/utex/blog/446944/',
  },
];
